import React, { useEffect, useRef, useState } from 'react';
import {
   Tabs,
   useViewList,
   useDidUpdateEffect,
   useDidUpdateDeepCompareLayoutEffect,
   ToastList,
   useSelectGroup,
} from '@devesharp/react/web';
import dateFNS from 'date-fns';
import { FormHandles } from '@unform/core';
import { useRecoilState } from 'recoil';
import {
   BankAccountsSearchResolve,
   BoletoCancelResolve,
   BookletsCancelResolve,
   BookletsSearchResolve,
   CustomersSearchResolve,
   GroupsSearchResolve,
   PaymentLinksSearchResolve,
} from '~/api';
import { BookletsListingPage } from '~/pages/BookletsListing/BookletsListingPage';
import history from '~/config/history';
import { companyShowInfoState } from '~/recoil/company-select.state';

export function useBookletsListingPage(): any {
   document.title = 'Carnês - XPAG Tecnologia';
   const [showSeller] = useRecoilState(companyShowInfoState);

   const {
      starting,
      searching,
      errorLoadData,
      reloadPage,
      registerResolveParams,
      registerOnInit,
      resources,
      resourcesTotal,
      skeletonResources,
      setFilters,
      setOffset,
      setPage,
      setSort,
      filters,
   } = useViewList({
      resolves: {
         items: BookletsSearchResolve,
         groups: GroupsSearchResolve,
      },
      filtersDefault: {},
   });

   const [onSelect, onUnselectAll, selected, checkSelected] = useSelectGroup();

   const [groups, setGroups] = useState<any[]>([]);
   const [loading, setLoading] = useState(false);
   const [currentPage, setCurrentPage] = useState(parseInt(((filters?.offset ?? 0) / 20) as any, 10) + 1);
   const formRef = useRef<FormHandles>();

   registerOnInit((resources: any) => {
      if (resources.groups) {
         setGroups(resources.groups.results);
      }
   });

   useDidUpdateEffect(() => {
      setPage(currentPage);
   }, [currentPage]);

   useEffect(() => {
      if (formRef.current) {
         formRef.current.setData(filters);
      }
      onUnselectAll();
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
   }, [filters]);

   const filtersData = {
      groups: [
         {
            id: '',
            name: 'Todos',
         },
         ...groups.map((group) => ({
            id: group.id,
            name: group.name,
         })),
      ],
      status: [
         {
            id: '',
            name: 'Todos',
         },
         { id: 'succeeded', name: 'Pago' },
         { id: 'pending', name: 'Pendente' },
         { id: 'expired', name: 'Expirado' },
      ],
   };

   function onSubmit(data: any) {
      const params = data;
      params.created_at_gte = data?.created_at_gte?.dateYYYYMMDD;
      params.created_at_lte = data?.created_at_lte?.dateYYYYMMDD;

      setFilters(() => params);
   }

   function cancelBooklet(id: any): void {
      const confirmed = window.confirm('Deseja realmente cancelar o carnê? Todos os boletos serão cancelados');

      if (confirmed) {
         BookletsCancelResolve(id).subscribe(() => {
            ToastList.show({
               message: 'Carnê cancelado com sucesso',
               type: 'success',
            });

            reloadPage(false);
         });
      }
   }

   const page = filters.page ?? 1;
   let pageCountStart = (page - 1) * 20 + 1;
   pageCountStart = resourcesTotal ? pageCountStart : 0;
   let pageCountEnd = (page - 1) * 20 + 20;
   pageCountEnd = pageCountEnd > resourcesTotal ? resourcesTotal : pageCountEnd;

   return {
      onSubmit,
      cancelBooklet,
      setSort,
      formRef,
      reloadPage,
      starting,
      searching,
      loading,
      pageCountStart,
      pageCountEnd,
      errorLoadData,
      resources,
      resourcesTotal,
      skeletonResources,
      filters,
      filtersData,
      currentPage,
      setCurrentPage,
      onSelect,
      onUnselectAll,
      selected,
      showSeller,
      checkSelected,
   };
}
